(function () {

  'use strict';

  function pxPrinterListContextMenu(
    $timeout, $window, CopilotService
    ) {
    return {
      restrict: 'E',
      scope: {
        context: '=context',
        resource: '=resource',
        auxiliaries: '=auxiliaries',
        selectedTab: '=selectedTab',
        placeInCenter: '=placeInCenter',
        contextPosition: '=contextPosition',
        callback: '&callback',
        updateParent: '&updateParent'
      },
      // TEMPLATE USAGE -> px-on-device-config-context-menu // APPROVED
      templateUrl: 'app/components/printerList/_printerListContextMenu/printerListContextMenu.template.html',
      link: function (scope, element, attrs) {

        scope.closePopup = function (bypass) {
          if (!bypass) {
            scope.callback({selectedContextMenuItem: null, contextPosition: null, contextContent: null});
          }
        }

        scope.relayUpdateParent = function () {
          scope.updateParent();
        }

        scope.$on('$destroy', function() {
          angular.element('.context-content-container').css({display: 'none'});
        });

      }
    }
  }



  pxPrinterListContextMenu.$inject = ['$timeout', '$window', 'CopilotService'];

  angular
    .module('printix-admin')
    .directive('pxPrinterListContextMenu', pxPrinterListContextMenu);

})();
